
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("25vN5", function(module, exports) {

$parcel$export(module.exports, "JPDIdeasPanelComponent", () => $97fbac628a0d2f43$export$e2ac425f1199ffc9);
$parcel$export(module.exports, "JPDIdeasPanel", () => $97fbac628a0d2f43$export$4dbf85c80f9d5a15);
$parcel$export(module.exports, "default", () => $97fbac628a0d2f43$export$2e2bcd8739ae039);

var $izVuZ = parcelRequire("izVuZ");

var $i3OJl = parcelRequire("i3OJl");

var $34QUW = parcelRequire("34QUW");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $Ys7jv = parcelRequire("Ys7jv");

var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $bmoS1 = parcelRequire("bmoS1");

var $cBavF = parcelRequire("cBavF");

var $1KdDN = parcelRequire("1KdDN");

var $7jTnu = parcelRequire("7jTnu");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $hpZaA = parcelRequire("hpZaA");

var $6VzZU = parcelRequire("6VzZU");

var $1MNtF = parcelRequire("1MNtF");

var $284TU = parcelRequire("284TU");

var $cB9ze = parcelRequire("cB9ze");

var $8F02X = parcelRequire("8F02X");

var $9UkBS = parcelRequire("9UkBS");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kEUB1 = parcelRequire("kEUB1");

var $16sa1 = parcelRequire("16sa1");

var $6XJko = parcelRequire("6XJko");

var $kqd31 = parcelRequire("kqd31");

var $b5oGV = parcelRequire("b5oGV");

var $bbdV2 = parcelRequire("bbdV2");

var $e8eEj = parcelRequire("e8eEj");

var $jycCs = parcelRequire("jycCs");

var $9FmCE = parcelRequire("9FmCE");

var $kImJO = parcelRequire("kImJO");

var $5Pl2q = parcelRequire("5Pl2q");

var $nfbY3 = parcelRequire("nfbY3");

var $eg484 = parcelRequire("eg484");

var $3uJXf = parcelRequire("3uJXf");

var $5XbzI = parcelRequire("5XbzI");

var $kWDaK = parcelRequire("kWDaK");

var $aVRzo = parcelRequire("aVRzo");
const $97fbac628a0d2f43$var$PRODUCT_DISCOVERY = 'PRODUCT_DISCOVERY';
const $97fbac628a0d2f43$var$entryPointParams = {};
const $97fbac628a0d2f43$export$e2ac425f1199ffc9 = ({ issueViewRelayFragment: issueViewRelayFragment, jpdDeliveryIssueLinkTypeId: jpdDeliveryIssueLinkTypeId, shouldShowAddIssueLinks: shouldShowAddIssueLinks = false, onShowLinkIdeaInput: onShowLinkIdeaInput })=>{
    const [viewedChangeBoarding] = (0, $jycCs.useIdeaPanelChangeBoarding)();
    const urlSelectedIdeaKey = (0, $9FmCE.useSelectedIdeaKey)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubjectAddJPDIdea } = (0, $bbdV2.useEntryPoint)((0, $aVRzo.createAddJPDLinkEntrypoint), $97fbac628a0d2f43$var$entryPointParams);
    // needs to be migrated to 2 triggers with prop drilling, doing it this way to get perf gains earlier
    // https://atlassian.slack.com/archives/C07JUC8ALCT/p1753768586722859 more context
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (shouldShowAddIssueLinks) entryPointActions.load();
    }, [
        entryPointActions,
        shouldShowAddIssueLinks
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            if (urlSelectedIdeaKey) (0, $b5oGV.experience).ideaViewBentoSidebar.pageSegmentLoad.abort('panel_unmount_query_param');
            else (0, $b5oGV.experience).ideaViewBentoSidebar.pageSegmentLoad.abort('panel_unmount');
        };
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const data = (0, $j4oe4.useFragment)((0, $34QUW.default), issueViewRelayFragment?.issueLinks);
    const [unlinkIdeaMutationCommit] = (0, $j4oe4.useMutation)((0, $i3OJl.default));
    const connectionId = data?.__id;
    const onUnlinkModalConfirmed = (0, $eJOHy.useCallback)((issueLinkId)=>{
        unlinkIdeaMutationCommit({
            variables: {
                cloudId: cloudId,
                issueLinkId: issueLinkId
            },
            updater: (store, payload)=>{
                const { success: success, deletedIds: deletedIds } = payload?.jira?.deleteIssueLink ?? {};
                if (success) {
                    if (connectionId) {
                        const connection = store.get(connectionId);
                        if (connection) {
                            const nodeIds = deletedIds?.map((deletedId)=>(0, $kqd31.default)({
                                    id: deletedId
                                }, 'JiraIssueLink'));
                            nodeIds?.forEach((nodeId)=>{
                                if (nodeId) (0, $j4oe4.ConnectionHandler).deleteNode(connection, nodeId);
                            });
                            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'idea unlinked');
                        }
                    }
                }
            },
            onError: ()=>{
                showFlag({
                    type: 'error',
                    title: formatMessage((0, $kWDaK.messages).unlinkIdeaErrorFlagTitle),
                    description: formatMessage((0, $kWDaK.messages).unlinkIdeaErrorFlagDescription),
                    isAutoDismiss: true,
                    messageId: 'issue-view-jpd-ideas.ui.show-flag.error.unlink-idea-error',
                    messageType: 'transactional'
                });
            }
        });
    }, [
        cloudId,
        connectionId,
        createAnalyticsEvent,
        unlinkIdeaMutationCommit,
        formatMessage,
        showFlag
    ]);
    const ideaLinks = (0, $eJOHy.useMemo)(()=>(data?.edges || []).filter((link)=>link?.node?.issue?.fieldsById?.edges?.some((edge)=>edge?.node?.__typename === 'JiraProjectField' && edge?.node?.project?.projectType === $97fbac628a0d2f43$var$PRODUCT_DISCOVERY)), [
        data?.edges
    ]);
    const ideaLinksProps = (0, $eJOHy.useMemo)(()=>ideaLinks.map((link)=>{
            const issue = link?.node?.issue;
            const issueLinkId = link?.node?.issueLinkId;
            const isDeliveryIssueLinkType = jpdDeliveryIssueLinkTypeId && link?.node?.type?.linkTypeId === jpdDeliveryIssueLinkTypeId && link?.node?.direction === (0, $hpZaA.OUTWARD_LINK_DIRECTION);
            if (!issue?.key || issueLinkId === null) return null;
            if (!isDeliveryIssueLinkType && (0, $7jTnu.fg)('jpd_idea_panel_in_issue_view')) return null;
            const summaryEdge = issue?.fieldsById?.edges?.find((edge)=>edge?.node?.__typename === 'JiraSingleLineTextField' && edge?.node?.fieldId === 'summary');
            const issueTypeEdge = issue?.fieldsById?.edges?.find((edge)=>edge?.node?.__typename === 'JiraIssueTypeField');
            const summary = summaryEdge?.node && 'text' in summaryEdge.node && summaryEdge.node.text || '';
            const issueType = issueTypeEdge?.node && 'issueType' in issueTypeEdge.node ? issueTypeEdge.node.issueType : undefined;
            return {
                issueId: issue.issueId,
                issueKey: issue.key,
                summary: summary,
                issueTypeIconUrl: issueType?.avatar?.medium ?? undefined,
                issueTypeName: issueType?.name,
                issueLinkId: issueLinkId
            };
        }).filter(Boolean), [
        ideaLinks,
        jpdDeliveryIssueLinkTypeId
    ]);
    const runtimeAddIdeaProps = (0, $eJOHy.useMemo)(()=>({
            ideaLinksProps: ideaLinksProps,
            jpdDeliveryIssueLinkTypeId: jpdDeliveryIssueLinkTypeId,
            connectionId: connectionId
        }), [
        ideaLinksProps,
        jpdDeliveryIssueLinkTypeId,
        connectionId
    ]);
    const { setEntryPointReferenceSubject: setEntryPointReferenceSubject } = (0, $e8eEj.useActiveEntryPointSubjectActions)();
    const [entryPointReferenceSubject] = (0, $e8eEj.useActiveEntryPointSubject)();
    const handleOnSidebarClose = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setEntryPointReferenceSubject(null, true);
    }, [
        setEntryPointReferenceSubject
    ]);
    const handleOnEntryPointClose = (0, $eJOHy.useCallback)(()=>{
        setEntryPointReferenceSubject(null, true);
    }, [
        setEntryPointReferenceSubject
    ]);
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            setEntryPointReferenceSubject(null);
        };
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderIdeaCards = ()=>{
        if (ideaLinksProps.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
            name: "issue-jpd-ideas"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
            xcss: (0, $6XJko.isVisualRefreshEnabled)() ? $97fbac628a0d2f43$var$containerStyles : $97fbac628a0d2f43$var$containerStylesOld
        }, ideaLinksProps.map((linkProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5XbzI.IdeaCard), {
                key: linkProps.issueKey,
                ...linkProps,
                onUnlinkModalConfirmed: onUnlinkModalConfirmed,
                isUrlSelected: linkProps.issueKey === urlSelectedIdeaKey
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ys7jv.default), {
            appear: true
        }, entryPointReferenceSubject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9UkBS.RightSidebar), {
            onClose: handleOnSidebarClose
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
            id: "async-jpd-idea-sidebar-view",
            packageName: "jira-polaris-component-idea-view-bento-sidebar",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: {
                onClose: handleOnEntryPointClose
            },
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8F02X.IdeaViewSkeleton), null),
            errorFallback: "flag"
        }))));
    };
    if (ideaLinksProps.length || shouldShowAddIssueLinks) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "linkedIdeasPanel",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        attributes: {
            linkedIdeasCount: ideaLinks.length
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1MNtF.SectionHeading), null, !viewedChangeBoarding && (0, $7jTnu.fg)('polaris_-_jpd_in_jsw_change_boarding_killswitch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1MNtF.SectionHeadingTitle), null, formatMessage((0, $kWDaK.messages).ideasTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Pl2q.ChangeBordingLozenge), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1MNtF.SectionHeadingTitle), null, formatMessage((0, $kWDaK.messages).ideasTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6VzZU.default), {
        label: formatMessage((0, $kWDaK.messages).plusButtonLabel),
        onClick: onShowLinkIdeaInput
    })), renderIdeaCards(), shouldShowAddIssueLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubjectAddJPDIdea,
        id: "jpd-add-idea-entrypoint",
        packageName: "jpd-add-idea-entrypoint",
        fallback: null,
        runtimeProps: runtimeAddIdeaProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97fbac628a0d2f43$var$IdeasDiscoveryCardEligibilityWrapper, {
        issueViewRelayFragment: issueViewRelayFragment
    });
};
const $97fbac628a0d2f43$var$IdeasDiscoveryCardEligibilityWrapper = ({ issueViewRelayFragment: issueViewRelayFragment })=>{
    const data = (0, $j4oe4.useFragment)((0, $izVuZ.default), issueViewRelayFragment);
    const eligibilityProps = {
        issueType: {
            name: data?.issueTypeField?.name,
            level: data?.issueTypeField?.issueType?.hierarchy?.level
        },
        statusCategoryId: data?.statusCategory?.statusCategoryId,
        canLinkIssues: data?.canLinkIssues
    };
    const shouldShowIdeaDiscoveryCard = (0, $kImJO.useCrossflowIdeaCardEligible)(eligibilityProps);
    if (!shouldShowIdeaDiscoveryCard) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97fbac628a0d2f43$var$IdeasDiscoveryCard, null);
};
const $97fbac628a0d2f43$var$IdeasDiscoveryCard = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { dismiss: dismiss, isDismissed: isDismissed } = (0, $nfbY3.useAdControlsFunctionality)({
        userPropertyCrossflowIdeasCard: 'hasDismissedCrossflowIdeaCard'
    });
    const currentIssueKey = (0, $bmoS1.useIssueKey)();
    const currentIssueId = (0, $bmoS1.useIssueId)();
    if (isDismissed || !currentIssueKey || !currentIssueId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "issue-jpd-idea-discovery-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "CrossflowIdeaCard",
        packageName: "issue-view-ideas-panel",
        teamName: "galileo",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "crossflowIdeaCard",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a),
        attributes: {
            issueKey: currentIssueKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1MNtF.SectionHeading), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1MNtF.SectionHeadingTitle), null, formatMessage((0, $kWDaK.messages).ideasTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eg484.default), {
        onDismissClick: dismiss
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        xcss: (0, $6XJko.isVisualRefreshEnabled)() ? $97fbac628a0d2f43$var$containerStyles : $97fbac628a0d2f43$var$containerStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3uJXf.CrossflowIdeaCard), {
        inwardIssueKey: currentIssueKey,
        inwardIssueId: currentIssueId,
        onDismissAd: dismiss
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null)))));
};
const $97fbac628a0d2f43$var$JPDIdeaPanelWrapped = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "issueViewJpdIdeas",
        fallback: "unmount",
        teamName: "JPD - Juno",
        packageName: "@atlassian/jira-issue-view-jpd-ideas"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($97fbac628a0d2f43$export$e2ac425f1199ffc9, props));
};
const $97fbac628a0d2f43$export$4dbf85c80f9d5a15 = (0, $284TU.connect)(()=>({}), (dispatch)=>({
        onShowLinkIdeaInput: ()=>{
            dispatch((0, $cB9ze.showLinkIdeaInput)());
        }
    }))($97fbac628a0d2f43$var$JPDIdeaPanelWrapped);
const $97fbac628a0d2f43$var$containerStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.025'
});
const $97fbac628a0d2f43$var$containerStylesOld = (0, $1DXK0.xcss)({
    boxShadow: 'elevation.shadow.raised',
    borderRadius: 'border.radius.100'
});
var // needed for importCond, remove default export once the importCond is removed (fg: fy26_nike_box_bundle_decrease_project)
$97fbac628a0d2f43$export$2e2bcd8739ae039 = $97fbac628a0d2f43$export$4dbf85c80f9d5a15;

});
parcelRegister("izVuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e921fe8a548d0f0a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1eb8a5f3ebb0569f706948ccafd1ef42>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e921fe8a548d0f0a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ui_issueViewJpdIdeas_IdeasDiscoveryCardEligibilityWrapper_issueViewRelayFragment",
    "selections": [
        {
            "alias": "canLinkIssues",
            "args": [
                {
                    "kind": "Literal",
                    "name": "permission",
                    "value": "LINK_ISSUES"
                }
            ],
            "kind": "ScalarField",
            "name": "hasProjectPermission",
            "storageKey": "hasProjectPermission(permission:\"LINK_ISSUES\")"
        },
        {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "statusCategoryId"
                    },
                    "action": "LOG",
                    "path": "statusCategory.statusCategoryId"
                }
            ]
        },
        {
            "concreteType": "JiraIssueTypeField",
            "kind": "LinkedField",
            "name": "issueTypeField",
            "plural": false,
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    "action": "LOG",
                    "path": "issueTypeField.name"
                },
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueTypeHierarchyLevel",
                            "kind": "LinkedField",
                            "name": "hierarchy",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "level"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$e921fe8a548d0f0a$var$node.hash = "e06279682aee2498332184b9d51aa663";
var $e921fe8a548d0f0a$export$2e2bcd8739ae039 = $e921fe8a548d0f0a$var$node;

});

parcelRegister("i3OJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $13b78b2530250883$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<26cc895a648b0bab1c864aab5e1d5b77>>
 * @relayHash d901d35fabd9719b1f617f8d9ebdc537
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a7a0b56fd412e9bdb1efbc889ed8f61988f64f3f19ddfea11a99b1c26f94530c
const $13b78b2530250883$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueLinkId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "issueLinkId",
            "variableName": "issueLinkId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "deletedIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "uiUnlinkIdeaMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDeleteIssueLinkPayload",
                            "kind": "LinkedField",
                            "name": "deleteIssueLink",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "uiUnlinkIdeaMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraDeleteIssueLinkPayload",
                            "kind": "LinkedField",
                            "name": "deleteIssueLink",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a7a0b56fd412e9bdb1efbc889ed8f61988f64f3f19ddfea11a99b1c26f94530c",
            "metadata": {},
            "name": "uiUnlinkIdeaMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$13b78b2530250883$var$node.hash = "e77201428b6cdacc072498d9e2de302e";
var $13b78b2530250883$export$2e2bcd8739ae039 = $13b78b2530250883$var$node;

});

parcelRegister("34QUW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4a4526533e6124$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f529f2bcd1650e1706a4915343ed86dd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6a4a4526533e6124$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ui_issueViewJpdIdeas_JPDIdeasPanel",
        "selections": [
            {
                "concreteType": "JiraIssueLinkEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueLink",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "issueLinkId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "direction"
                            },
                            {
                                "concreteType": "JiraIssueLinkType",
                                "kind": "LinkedField",
                                "name": "type",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "linkTypeId"
                                    }
                                ]
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "issueId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    },
                                    {
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "ids",
                                                "value": [
                                                    "assignee",
                                                    "issuetype",
                                                    "priority",
                                                    "status",
                                                    "summary",
                                                    "project"
                                                ]
                                            }
                                        ],
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fieldsById",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueFieldEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__typename"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    v2 /*: any*/ ,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "text"
                                                                    }
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "projectType"
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraProjectField"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    v2 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v2 /*: any*/ ,
                                                                            {
                                                                                "concreteType": "JiraAvatar",
                                                                                "kind": "LinkedField",
                                                                                "name": "avatar",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "medium"
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "fieldsById(ids:[\"assignee\",\"issuetype\",\"priority\",\"status\",\"summary\",\"project\"])"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraIssueLinkConnection"
    };
}();
$6a4a4526533e6124$var$node.hash = "fa0b2866f22db8eb2dfa658167e1b3cb";
var $6a4a4526533e6124$export$2e2bcd8739ae039 = $6a4a4526533e6124$var$node;

});

parcelRegister("8F02X", function(module, exports) {

$parcel$export(module.exports, "IdeaViewSkeleton", () => $13115e35b4d3af90$export$d672704340077760);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $aewX5 = parcelRequire("aewX5");
var $3Wh6p = parcelRequire("3Wh6p");
var $dW738 = parcelRequire("dW738");
var $1DXK0 = parcelRequire("1DXK0");

var $9A8Wt = parcelRequire("9A8Wt");
const $13115e35b4d3af90$var$ROWS_COUNT = 8;
const $13115e35b4d3af90$export$d672704340077760 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        padding: "space.200",
        xcss: $13115e35b4d3af90$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "16px",
        width: "16px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "16px",
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "16px",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3Wh6p.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "24px",
        width: "24px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "24px",
        width: "24px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "24px",
        width: "24px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "24px",
        width: "24px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "16px",
        width: "80%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "16px",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "16px",
        width: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "16px",
        width: "80%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "16px",
        width: "40%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
        height: "100px",
        width: "100px"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.200"
    }, [
        ...Array($13115e35b4d3af90$var$ROWS_COUNT)
    ].map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aewX5.default), {
            key: index,
            templateColumns: "[title] minmax(100px, 0.6fr) [content] 1fr",
            gap: "space.100",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            padding: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
            height: "16px",
            width: "48px"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9A8Wt.SkeletonCompiled), {
            width: "100px",
            height: "16px"
        }))))));
const $13115e35b4d3af90$var$containerStyles = (0, $1DXK0.xcss)({
    width: '100%',
    position: 'absolute',
    top: 'space.0',
    bottom: 'space.0',
    paddingTop: 'space.300',
    paddingBottom: 'space.200',
    paddingRight: 'space.300',
    paddingLeft: 'space.300'
});

});

parcelRegister("9UkBS", function(module, exports) {

$parcel$export(module.exports, "RightSidebar", () => $4d949b799051786b$export$84d58c19c21f637f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $edcPh = parcelRequire("edcPh");

var $8UpxG = parcelRequire("8UpxG");

var $67YQP = parcelRequire("67YQP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $dPMMf = parcelRequire("dPMMf");

var $Tqatc = parcelRequire("Tqatc");
const $4d949b799051786b$export$84d58c19c21f637f = ({ children: children, onClose: onClose })=>{
    (0, $edcPh.useCloseOnEscapePress)({
        onClose: onClose
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Tqatc.OutsideClickAlerter), {
        onClickOutside: onClose
    }, (outsideClickAlerterProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $67YQP.default), {
            zIndex: (0, $dPMMf.layers).rightSidebar
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8UpxG.default), {
            enterFrom: "right",
            fade: "none"
        }, ({ ref: ref, className: className })=>// this is the way motion library is intended to be used
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4d949b799051786b$var$AnimationContainer, {
                ref: ref,
                className: className
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                xcss: $4d949b799051786b$var$sidebarStyles,
                onMouseDownCapture: outsideClickAlerterProps.onMouseDownCapture,
                onTouchEndCapture: outsideClickAlerterProps.onTouchEndCapture
            }, children)))));
};
// - the animations only work with styled components
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4d949b799051786b$var$AnimationContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bsbdgin _kqsw1n9t _1xi2idpf _94n5idpf _4t3i1i8v",
            __cmplp.className
        ])
    });
});
const $4d949b799051786b$var$sidebarStyles = (0, $1DXK0.xcss)({
    height: '100%',
    width: '500px',
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    clipPath: 'inset(0px 0px 0px -15px)' // Remove shadow everywhere except on the left side of the sidebar
});

});
parcelRegister("Tqatc", function(module, exports) {

$parcel$export(module.exports, "OutsideClickAlerter", () => $29534af6b855606b$export$88de4b185c4a8c09);
$parcel$export(module.exports, "isFocusOutsideJFE", () => $29534af6b855606b$export$901087bc7dae0943);

var $eJOHy = parcelRequire("eJOHy");
const $29534af6b855606b$export$88de4b185c4a8c09 = ({ onClickOutside: onClickOutside, children: children })=>{
    const innerClickRef = (0, $eJOHy.useRef)(false);
    const clickStartRef = (0, $eJOHy.useRef)(false);
    const handleClick = (0, $eJOHy.useCallback)((e)=>{
        if (clickStartRef.current && !innerClickRef.current && e.target) onClickOutside && onClickOutside(e);
        innerClickRef.current = false;
        clickStartRef.current = false;
    }, [
        onClickOutside
    ]);
    const innerClick = (0, $eJOHy.useCallback)(()=>{
        innerClickRef.current = true;
    }, []);
    const clickStart = (0, $eJOHy.useCallback)(()=>{
        clickStartRef.current = true;
    }, []);
    (0, $eJOHy.useEffect)(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mousedown', clickStart, true);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('touchstart', clickStart, true);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('click', handleClick, true);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('touchend', handleClick, true);
        // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('drop', handleClick, true);
        // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('dragend', handleClick, true);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('mousedown', clickStart, true);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('touchstart', clickStart, true);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('click', handleClick, true);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('touchend', handleClick, true);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('drop', handleClick, true);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('dragend', handleClick, true);
        };
    }, [
        handleClick,
        clickStart
    ]);
    const childRenderProps = (0, $eJOHy.useMemo)(()=>({
            onMouseDownCapture: innerClick,
            onTouchEndCapture: innerClick
        }), [
        innerClick
    ]);
    return children(childRenderProps);
};
const $29534af6b855606b$export$901087bc7dae0943 = (target)=>{
    if (target instanceof HTMLElement) return(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    !document.querySelector('#jira-frontend')?.contains(target) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    window.IS_STORYBOOK !== true);
    return false;
};
const $29534af6b855606b$export$34447fad920c5f9c = (storyFn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        id: "jira-frontend"
    }, storyFn());

});


// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("b5oGV", function(module, exports) {

$parcel$export(module.exports, "experience", () => $8f97456e719527e2$export$45794d16c9d83fe2);

var $5F7lp = parcelRequire("5F7lp");

var $5hijW = parcelRequire("5hijW");

var $dxu1o = parcelRequire("dxu1o");

var $dNeB5 = parcelRequire("dNeB5");

var $j5OkA = parcelRequire("j5OkA");

var $kzS1T = parcelRequire("kzS1T");

var $dzKqr = parcelRequire("dzKqr");

var $5HKXk = parcelRequire("5HKXk");

var $2nJkH = parcelRequire("2nJkH");

var $ZQxd9 = parcelRequire("ZQxd9");

var $4q2vI = parcelRequire("4q2vI");

var $1aCfx = parcelRequire("1aCfx");

var $arGNf = parcelRequire("arGNf");

var $9y6V7 = parcelRequire("9y6V7");

var $dRhKl = parcelRequire("dRhKl");

var $1OdQL = parcelRequire("1OdQL");

var $cYJdB = parcelRequire("cYJdB");

var $4FxxH = parcelRequire("4FxxH");

var $caQ0a = parcelRequire("caQ0a");

var $aE5Um = parcelRequire("aE5Um");

var $jGUrD = parcelRequire("jGUrD");

var $kjiOd = parcelRequire("kjiOd");

var $jRmYD = parcelRequire("jRmYD");
const $8f97456e719527e2$export$45794d16c9d83fe2 = {
    listView: $1aCfx,
    formulaField: $kzS1T,
    headerView: $5HKXk,
    boardView: $5F7lp,
    ideaView: $ZQxd9,
    ideaViewBentoSidebar: $2nJkH,
    matrixView: $arGNf,
    navBar: $9y6V7,
    project: $cYJdB,
    timelineView: $caQ0a,
    fieldsSidebar: $j5OkA,
    issues: $4q2vI,
    deliveryItems: $dNeB5,
    sharing: $4FxxH,
    globalFieldsAdministration: $dzKqr,
    playSidepanel: $1OdQL,
    noViewsScreen: $dRhKl,
    view: $jGUrD,
    viewPermissions: $aE5Um,
    collections: $5hijW,
    copyProjectConfiguration: $dxu1o,
    connections: $kjiOd,
    issueTypes: $jRmYD
};

});
parcelRegister("5F7lp", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoad", () => $8b01a26415d8b0ec$export$94114666844d5f66);
$parcel$export(module.exports, "scrollPerformance", () => $8b01a26415d8b0ec$export$390e7f040546632b);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $8b01a26415d8b0ec$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.board-view', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $8b01a26415d8b0ec$export$390e7f040546632b = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.board-view.scroll-performance', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
}));

});
parcelRegister("8XCY1", function(module, exports) {

$parcel$export(module.exports, "createMarkedJpdExperience", () => $20b9c80b1c31e99d$export$bffa5dc83c7b8f85);
$parcel$export(module.exports, "createJpdExperience", () => $20b9c80b1c31e99d$export$2510480a5584184);
$parcel$export(module.exports, "wrapPromiseWithExperience", () => $20b9c80b1c31e99d$export$745ef3600a4acb32);
$parcel$export(module.exports, "wrapWithExperience", () => $20b9c80b1c31e99d$export$9527dfc663dbb238);
$parcel$export(module.exports, "createExperienceWithMetaType", () => $20b9c80b1c31e99d$export$e3ba910cdcb797bc);

var $l5Z0K = parcelRequire("l5Z0K");

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");

var $8KUFq = parcelRequire("8KUFq");

var $7jTnu = parcelRequire("7jTnu");
const $20b9c80b1c31e99d$export$bffa5dc83c7b8f85 = (ufoExperience, marks)=>({
        ...$20b9c80b1c31e99d$export$2510480a5584184(ufoExperience),
        marks: marks
    });
const $20b9c80b1c31e99d$export$a6d727308d53fe0e = (handler, error)=>{
    if (error === undefined) {
        handler();
        return;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($l5Z0K)))(error)) {
        handler({
            metadata: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                error: error
            }
        });
        return;
    }
    if (typeof error === 'object' && error !== null) {
        const errorStatus = 'statusCode' in error && error.statusCode ? `[${error.statusCode}] ` : '';
        const errorName = 'name' in error && error.name ? `${error.name}` : '';
        const errorMessage = 'message' in error ? ` - ${error.message}` : '';
        const errorString = `${errorStatus}${errorName}${errorMessage}`; // example: "[404] FetchError  - Not Found"
        const traceId = typeof error === 'object' && 'traceId' in error ? error.traceId : undefined;
        if (!errorName && !errorStatus && !errorMessage) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return handler(error);
        return handler({
            metadata: {
                error: errorString,
                errors: 'errors' in error && Array.isArray(error.errors) ? error.errors.map((err)=>{
                    if (typeof err === 'string') return err;
                    if (typeof err === 'object' && err !== null && 'error' in err) return err.error;
                    return '';
                }).join(', ') : undefined,
                traceId: traceId
            }
        });
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    handler(error);
};
const $20b9c80b1c31e99d$export$2510480a5584184 = (ufoExperience)=>({
        ufoExperience: ufoExperience,
        start: (startTime)=>{
            ufoExperience.start();
            // hack to set custom start time
            if (startTime !== undefined) Object.assign(ufoExperience.metrics, {
                ...ufoExperience.metrics,
                startTime: startTime
            });
        },
        mark: (mark)=>{
            ufoExperience.mark(mark);
        },
        success: (meta, endTime)=>{
            ufoExperience.success(meta);
            // hack to set custom end time
            if (endTime !== undefined) Object.assign(ufoExperience.metrics, {
                ...ufoExperience.metrics,
                endTime: endTime
            });
        },
        successWithReason: (reason)=>{
            $20b9c80b1c31e99d$export$a6d727308d53fe0e((meta)=>ufoExperience.success(meta), reason);
        },
        failure: (reason)=>{
            $20b9c80b1c31e99d$export$a6d727308d53fe0e((meta)=>ufoExperience.failure(meta), reason);
        },
        abort: (reason)=>{
            $20b9c80b1c31e99d$export$a6d727308d53fe0e((meta)=>ufoExperience.abort(meta), reason);
        }
    });
const $20b9c80b1c31e99d$export$745ef3600a4acb32 = (promise, experience, errorAnalyticsId, isExperienceErrorAborted)=>{
    experience.start();
    return promise.then((response)=>{
        experience.success();
        return response;
    }).catch((error)=>{
        if (errorAnalyticsId) (0, $gYnSx.default)({
            meta: {
                id: errorAnalyticsId,
                teamName: 'polaris'
            },
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        if ((0, $8KUFq.isClientFetchError)(error)) {
            experience.abort(error);
            throw error;
        }
        if ((0, $1uIew.isValidationError)(error)) {
            experience.abort(error);
            throw error;
        }
        if ((0, $7jTnu.fg)('jpd_improved_get_issue__slo')) {
            if (isExperienceErrorAborted && isExperienceErrorAborted(error)) {
                experience.abort(error);
                throw error;
            }
        }
        experience.failure(error);
        throw error;
    });
};
const $20b9c80b1c31e99d$export$9527dfc663dbb238 = (experience, callback)=>{
    experience.start();
    return callback().then((result)=>{
        experience.success();
        return result;
    }).catch((error)=>{
        if ((0, $8KUFq.isClientFetchError)(error)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            experience.abort(error);
            throw error;
        }
        if (error instanceof Error) experience.failure(error);
        throw error;
    });
};
const $20b9c80b1c31e99d$export$e3ba910cdcb797bc = (experience, metaType, parseMetadataError)=>({
        ufoExperience: experience.ufoExperience,
        start: experience.start,
        mark: experience.mark,
        success: (meta, endTime)=>{
            experience.success({
                metadata: {
                    type: metaType
                },
                ...meta
            }, endTime);
        },
        successWithReason: (error)=>{
            experience.successWithReason({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
        },
        failure: (error)=>{
            if (error && (0, $8KUFq.isClientFetchError)(error)) experience.abort({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
            else experience.failure({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
        },
        abort: (error)=>{
            experience.abort({
                metadata: {
                    error: parseMetadataError(error),
                    type: metaType
                }
            });
        }
    });

});


parcelRegister("5hijW", function(module, exports) {

$parcel$export(module.exports, "pageLoad", () => $85ffd4fe8a4eb652$export$791d520f7e8058a5);
$parcel$export(module.exports, "create", () => $85ffd4fe8a4eb652$export$185802fd694ee1f5);
$parcel$export(module.exports, "loadCollections", () => $85ffd4fe8a4eb652$export$569b2ddb07e9ef58);
$parcel$export(module.exports, "loadViewCount", () => $85ffd4fe8a4eb652$export$136390ba2bb25e0b);
$parcel$export(module.exports, "loadUsers", () => $85ffd4fe8a4eb652$export$2c3a8e05396a78be);
$parcel$export(module.exports, "loadProjects", () => $85ffd4fe8a4eb652$export$14ec9adb679a31a1);
$parcel$export(module.exports, "createCollection", () => $85ffd4fe8a4eb652$export$c74125a8e3af6bb2);
$parcel$export(module.exports, "copyCollection", () => $85ffd4fe8a4eb652$export$36928e43600c4b00);
$parcel$export(module.exports, "deleteCollection", () => $85ffd4fe8a4eb652$export$3d16e031f6551662);
$parcel$export(module.exports, "updateCollection", () => $85ffd4fe8a4eb652$export$c0683150b517c317);
$parcel$export(module.exports, "loadCollection", () => $85ffd4fe8a4eb652$export$1f19ddbd9e78c2f5);
$parcel$export(module.exports, "loadCollectionViews", () => $85ffd4fe8a4eb652$export$a86e9e8b7168d682);
$parcel$export(module.exports, "loadCollectionDescription", () => $85ffd4fe8a4eb652$export$da25d48c64ab9a24);
$parcel$export(module.exports, "updateCollectionDescription", () => $85ffd4fe8a4eb652$export$95146d83152efba8);
$parcel$export(module.exports, "createView", () => $85ffd4fe8a4eb652$export$d7febe7b891e79f0);
$parcel$export(module.exports, "deleteView", () => $85ffd4fe8a4eb652$export$443d89549b135c95);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $85ffd4fe8a4eb652$export$791d520f7e8058a5 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageLoad
}));
const $85ffd4fe8a4eb652$export$185802fd694ee1f5 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.create', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$569b2ddb07e9ef58 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.load-collections', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$136390ba2bb25e0b = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.load-view-count', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$2c3a8e05396a78be = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.load-users', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$14ec9adb679a31a1 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.load-projects', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$c74125a8e3af6bb2 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.create-collection', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$36928e43600c4b00 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.copy-collection', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$3d16e031f6551662 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.delete-collection', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$c0683150b517c317 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.update-collection', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$1f19ddbd9e78c2f5 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.load-collection', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$a86e9e8b7168d682 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.load-collection-views', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$da25d48c64ab9a24 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.load-collection-description', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$95146d83152efba8 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.update-collection-description', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$d7febe7b891e79f0 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.create-view', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $85ffd4fe8a4eb652$export$443d89549b135c95 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.collections.delete-view', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("dxu1o", function(module, exports) {

$parcel$export(module.exports, "copy", () => $bc46650526d1059f$export$784d13d8ee351f07);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $bc46650526d1059f$export$784d13d8ee351f07 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.copy-project-configuration', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("dNeB5", function(module, exports) {

$parcel$export(module.exports, "loadChildIssues", () => $c5c675cc1b53a78c$export$df5c5945eb51ab10);
$parcel$export(module.exports, "loadAggregatedDeliveryProgressBasedOnProjectId", () => $c5c675cc1b53a78c$export$531ec6120f223bb8);
$parcel$export(module.exports, "loadAggregatedDeliveryProgress", () => $c5c675cc1b53a78c$export$12a1609f29cbb864);
$parcel$export(module.exports, "loadLinkedDeliveryTickets", () => $c5c675cc1b53a78c$export$a88d267f7658a3dc);
$parcel$export(module.exports, "loadTransitiveChildrenArjHierarchy", () => $c5c675cc1b53a78c$export$ffdb9dea53e75ee5);
$parcel$export(module.exports, "loadTransitiveChildrenInTwoLevelCoreHierarchy", () => $c5c675cc1b53a78c$export$f9f3d52ff0f7a0b8);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $c5c675cc1b53a78c$export$df5c5945eb51ab10 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.delivery-items.load.childIssues', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $c5c675cc1b53a78c$export$531ec6120f223bb8 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.delivery-items.load.aggregatedDeliveryProgressBasedOnProjectId', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $c5c675cc1b53a78c$export$12a1609f29cbb864 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.delivery-items.load.aggregatedDeliveryProgress', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $c5c675cc1b53a78c$export$a88d267f7658a3dc = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.delivery-items.load.linkedDeliveryTickets', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $c5c675cc1b53a78c$export$ffdb9dea53e75ee5 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.delivery-items.load.transitiveChildrenArjHierarchy', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $c5c675cc1b53a78c$export$f9f3d52ff0f7a0b8 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.delivery-items.load.transitiveChildrenInTwoLevelCoreHierarchy', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("j5OkA", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoad", () => $8c3ef38c4f350aec$export$94114666844d5f66);
$parcel$export(module.exports, "fieldToggle", () => $8c3ef38c4f350aec$export$76f0d602d0733e6d);
$parcel$export(module.exports, "fieldHide", () => $8c3ef38c4f350aec$export$413c667806d09e8e);
$parcel$export(module.exports, "fieldDelete", () => $8c3ef38c4f350aec$export$b246cee4a79b9379);
$parcel$export(module.exports, "fieldRegularCreate", () => $8c3ef38c4f350aec$export$9df4f5b7e476ce84);
$parcel$export(module.exports, "fieldFormulaCreate", () => $8c3ef38c4f350aec$export$27b3440b11d7d826);
$parcel$export(module.exports, "fieldPlayCreate", () => $8c3ef38c4f350aec$export$f2ca0d7a70f0d4fa);
$parcel$export(module.exports, "fieldConfigurationUpdate", () => $8c3ef38c4f350aec$export$bb265be09cbcf6b4);
$parcel$export(module.exports, "fieldOptionUpdate", () => $8c3ef38c4f350aec$export$dd81c54ce99ca034);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $8c3ef38c4f350aec$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.fields-sidebar.load', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $8c3ef38c4f350aec$export$76f0d602d0733e6d = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.fields-sidebar.field-toggle', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$413c667806d09e8e = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.fields-sidebar.field-hide', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$b246cee4a79b9379 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.fields-sidebar.field-delete', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$9df4f5b7e476ce84 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.fields-sidebar.field-regular-create', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$27b3440b11d7d826 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.fields-sidebar.field-formula-create', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$f2ca0d7a70f0d4fa = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.fields-sidebar.field-play-create', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$bb265be09cbcf6b4 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.fields-sidebar.field-configuration-update', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8c3ef38c4f350aec$export$dd81c54ce99ca034 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.fields-sidebar.field-option-update', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("kzS1T", function(module, exports) {

$parcel$export(module.exports, "precalculateFormulaFieldAllValuesSelector", () => $63aff75064371c7a$export$a228cb9f5622e166);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $63aff75064371c7a$export$a228cb9f5622e166 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.formula-field.precalculate-all-values-selector', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("dzKqr", function(module, exports) {

$parcel$export(module.exports, "pageLoad", () => $8714cc93eb6f9050$export$791d520f7e8058a5);
$parcel$export(module.exports, "globalFieldCreate", () => $8714cc93eb6f9050$export$b03352737479563);
$parcel$export(module.exports, "globalFieldDelete", () => $8714cc93eb6f9050$export$84497cb573c7d17);
$parcel$export(module.exports, "globalFieldAssociate", () => $8714cc93eb6f9050$export$65839e13cd248f9e);
$parcel$export(module.exports, "globalFieldUnassociate", () => $8714cc93eb6f9050$export$29a31286f27d1a2e);
$parcel$export(module.exports, "globalFieldCheckViewsUsage", () => $8714cc93eb6f9050$export$8b1a216a358cdd80);
$parcel$export(module.exports, "globalFieldUpdate", () => $8714cc93eb6f9050$export$62c234d94572bba2);
$parcel$export(module.exports, "globalFieldUpdateConfig", () => $8714cc93eb6f9050$export$a17a8741bdd2acf);
$parcel$export(module.exports, "globalFieldCheckProjectUsage", () => $8714cc93eb6f9050$export$d30c8e3ea8a9aa57);
$parcel$export(module.exports, "loadGlobalFields", () => $8714cc93eb6f9050$export$f71db070ee14476f);
$parcel$export(module.exports, "loadGlobalLabels", () => $8714cc93eb6f9050$export$c6682f53b5f48ef8);
$parcel$export(module.exports, "loadJpdProjects", () => $8714cc93eb6f9050$export$85d7e1fdff0f01b4);
$parcel$export(module.exports, "loadProjectsWithField", () => $8714cc93eb6f9050$export$867e6f0888bf4bd);
$parcel$export(module.exports, "fieldAddOptions", () => $8714cc93eb6f9050$export$317ab3380fbbaacc);
$parcel$export(module.exports, "fieldDeleteOption", () => $8714cc93eb6f9050$export$d55856fb0a38bf13);
$parcel$export(module.exports, "fieldRenameOption", () => $8714cc93eb6f9050$export$12e095e9d4e2e327);
$parcel$export(module.exports, "fieldMoveOptions", () => $8714cc93eb6f9050$export$ba026a86e3a2a2ee);
$parcel$export(module.exports, "copyValues", () => $8714cc93eb6f9050$export$2b4b550f6684d934);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $8714cc93eb6f9050$export$791d520f7e8058a5 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageLoad
}));
const $8714cc93eb6f9050$export$b03352737479563 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.field-create', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$84497cb573c7d17 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.field-delete', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$65839e13cd248f9e = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.field-associate', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$29a31286f27d1a2e = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.field-unassociate', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$8b1a216a358cdd80 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.field-check-views-usage', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$62c234d94572bba2 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.field-update', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$a17a8741bdd2acf = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.field-update-config', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$d30c8e3ea8a9aa57 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.field-check-project-usage', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$f71db070ee14476f = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.load-fields', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$c6682f53b5f48ef8 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.load-global-labels', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$85d7e1fdff0f01b4 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.load-jpd-projects', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$867e6f0888bf4bd = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.load-projects-with-field', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$317ab3380fbbaacc = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.field-add-options', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$d55856fb0a38bf13 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.field-delete-option', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$12e095e9d4e2e327 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.field-rename-option', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$ba026a86e3a2a2ee = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.field-move-options', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $8714cc93eb6f9050$export$2b4b550f6684d934 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global-fields-administration.copy-values', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("5HKXk", function(module, exports) {

$parcel$export(module.exports, "updateViewDescription", () => $35297c286530b4de$export$16660b9e64c03042);
$parcel$export(module.exports, "viewGroupBy", () => $35297c286530b4de$export$5537a4a396822165);
$parcel$export(module.exports, "viewSort", () => $35297c286530b4de$export$f29ab69847cb95c0);
$parcel$export(module.exports, "viewFilter", () => $35297c286530b4de$export$7a7ebd5529ec7d46);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $35297c286530b4de$export$16660b9e64c03042 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.header-view.update-view-description', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $35297c286530b4de$export$5537a4a396822165 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.header-view.view-group-by', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $35297c286530b4de$export$f29ab69847cb95c0 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.header-view.view-sort', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $35297c286530b4de$export$7a7ebd5529ec7d46 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.header-view.view-filter', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("2nJkH", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoad", () => $60f7e7d615582df4$export$94114666844d5f66);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $60f7e7d615582df4$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view-bento-sidebar', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));

});

parcelRegister("ZQxd9", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoad", () => $d83d8a16960e36f4$export$94114666844d5f66);
$parcel$export(module.exports, "directPageSegmentLoad", () => $d83d8a16960e36f4$export$ee08e8134696f146);
$parcel$export(module.exports, "summaryUpdate", () => $d83d8a16960e36f4$export$5622e807234df3bb);
$parcel$export(module.exports, "descriptionUpdate", () => $d83d8a16960e36f4$export$f8fe5931289a9815);
$parcel$export(module.exports, "deliveryTicketCreate", () => $d83d8a16960e36f4$export$a84a662b970b5ae);
$parcel$export(module.exports, "commentCreate", () => $d83d8a16960e36f4$export$18cd8f3c0240b0a7);
$parcel$export(module.exports, "insightCreate", () => $d83d8a16960e36f4$export$5fb856565362db95);
$parcel$export(module.exports, "insightUpdate", () => $d83d8a16960e36f4$export$db3376d543b8f2f0);
$parcel$export(module.exports, "insightDelete", () => $d83d8a16960e36f4$export$5cf5d5fb5df27ce4);
$parcel$export(module.exports, "issueLinkCreate", () => $d83d8a16960e36f4$export$c88b0a5d9f4319fc);
$parcel$export(module.exports, "commentsSegmentLoad", () => $d83d8a16960e36f4$export$c9255b3c7ce3b238);
$parcel$export(module.exports, "insightsSegmentLoad", () => $d83d8a16960e36f4$export$31d3301eb443a690);
$parcel$export(module.exports, "fileAttach", () => $d83d8a16960e36f4$export$97a2bd48ad08a74b);
$parcel$export(module.exports, "connectionsSegmentLoad", () => $d83d8a16960e36f4$export$ea0be4743e48989b);
$parcel$export(module.exports, "makeFieldUpdate", () => $d83d8a16960e36f4$export$c9a3588491d4a10b);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $d83d8a16960e36f4$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $d83d8a16960e36f4$export$ee08e8134696f146 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view-direct', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $d83d8a16960e36f4$export$5622e807234df3bb = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.summary-update', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$f8fe5931289a9815 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.description-update', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$a84a662b970b5ae = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.delivery-ticket-create', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$18cd8f3c0240b0a7 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.comment-create', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$5fb856565362db95 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.insight-create', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$db3376d543b8f2f0 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.insight-update', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$5cf5d5fb5df27ce4 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.insight-delete', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$c88b0a5d9f4319fc = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.issue-link-create', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$c9255b3c7ce3b238 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.comments', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $d83d8a16960e36f4$export$31d3301eb443a690 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.insights', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $d83d8a16960e36f4$export$97a2bd48ad08a74b = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.attach-file', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $d83d8a16960e36f4$export$ea0be4743e48989b = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.connections-tab', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $d83d8a16960e36f4$export$c9a3588491d4a10b = ()=>(0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.idea-view.field-update', {
        type: (0, $2lxLk.ExperienceTypes).Experience,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
    }));

});

parcelRegister("4q2vI", function(module, exports) {

$parcel$export(module.exports, "loadIssuesRestBatched", () => $3ad241a988f9ee65$export$b4c4374bf531f011);
$parcel$export(module.exports, "loadIssueRest", () => $3ad241a988f9ee65$export$f1cca26704284332);
$parcel$export(module.exports, "loadIssuesJpdApi", () => $3ad241a988f9ee65$export$edc886929f100d7e);
$parcel$export(module.exports, "loadIssueJpdApi", () => $3ad241a988f9ee65$export$21e6ded5e5c7786);
$parcel$export(module.exports, "loadIssuesRanksRestBatched", () => $3ad241a988f9ee65$export$7605559f436ef08a);
$parcel$export(module.exports, "loadIssuesRanksJpdApi", () => $3ad241a988f9ee65$export$173ed5a278c1732b);
$parcel$export(module.exports, "rankIssue", () => $3ad241a988f9ee65$export$dbff149eb80fd116);
$parcel$export(module.exports, "loadIssuePickerIssuesRest", () => $3ad241a988f9ee65$export$23a6e22f367c9283);
$parcel$export(module.exports, "globalJpdIssueCreate", () => $3ad241a988f9ee65$export$792186e7b1057ce9);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $3ad241a988f9ee65$export$b4c4374bf531f011 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issues.load.rest-batched', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$f1cca26704284332 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue.load.rest', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$edc886929f100d7e = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issues.load.jpd-api', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$21e6ded5e5c7786 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue.load.jpd-api', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$7605559f436ef08a = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issues.ranks.load.rest-batched', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$173ed5a278c1732b = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issues.ranks.load.jpd-api', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$dbff149eb80fd116 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue.rank', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$23a6e22f367c9283 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue-picker.load', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $3ad241a988f9ee65$export$792186e7b1057ce9 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.global.jpd.create-issue', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("1aCfx", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoad", () => $d75571d30db1d607$export$94114666844d5f66);
$parcel$export(module.exports, "createIdeaInline", () => $d75571d30db1d607$export$5ea76ff12d204976);
$parcel$export(module.exports, "createIdeaInlineBulk", () => $d75571d30db1d607$export$47ee03b76831577c);
$parcel$export(module.exports, "createIdeaInlineClickResponse", () => $d75571d30db1d607$export$f9ccaf2135e3de7d);
$parcel$export(module.exports, "changeViewName", () => $d75571d30db1d607$export$1375b601692f3137);
$parcel$export(module.exports, "listScrollPerformance", () => $d75571d30db1d607$export$98edb0fcdfb46224);
$parcel$export(module.exports, "makeFieldUpdate", () => $d75571d30db1d607$export$c9a3588491d4a10b);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $d75571d30db1d607$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.list-view', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $d75571d30db1d607$export$5ea76ff12d204976 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.list-view.create-idea-inline', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $d75571d30db1d607$export$47ee03b76831577c = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.list-view.create-idea-inline-bulk', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $d75571d30db1d607$export$f9ccaf2135e3de7d = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.list-view.create-idea-inline-button-click', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
}));
const $d75571d30db1d607$export$1375b601692f3137 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.list-view.change-view-name', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $d75571d30db1d607$export$98edb0fcdfb46224 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.list-view.scroll-performance', {
    type: (0, $2lxLk.ExperienceTypes).Operation,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom
}));
const $d75571d30db1d607$export$c9a3588491d4a10b = ()=>(0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.list-view.field-update', {
        type: (0, $2lxLk.ExperienceTypes).Experience,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
        timings: [
            {
                key: 'internal_state',
                endMark: 'backend_request_start'
            },
            {
                key: 'backend_request',
                startMark: 'backend_request_start'
            }
        ]
    }));

});

parcelRegister("arGNf", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoad", () => $8b1bd80fa2396b91$export$94114666844d5f66);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $8b1bd80fa2396b91$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.matrix-view', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));

});

parcelRegister("9y6V7", function(module, exports) {

$parcel$export(module.exports, "changeViewName", () => $61fb22fffcc35495$export$1375b601692f3137);
$parcel$export(module.exports, "changeViewRank", () => $61fb22fffcc35495$export$52abe324a1859929);
$parcel$export(module.exports, "createView", () => $61fb22fffcc35495$export$d7febe7b891e79f0);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $61fb22fffcc35495$export$1375b601692f3137 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.nav-bar.change-view-name', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $61fb22fffcc35495$export$52abe324a1859929 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.nav-bar.change-view-rank', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $61fb22fffcc35495$export$d7febe7b891e79f0 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.nav-bar.create-view', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("dRhKl", function(module, exports) {

$parcel$export(module.exports, "createView", () => $938b0208b41d52dc$export$d7febe7b891e79f0);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $938b0208b41d52dc$export$d7febe7b891e79f0 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.no-views-screen.create-view', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("1OdQL", function(module, exports) {

$parcel$export(module.exports, "updatePlayField", () => $502df02e68126e64$export$870e1a1a0d62147f);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $502df02e68126e64$export$870e1a1a0d62147f = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.play-sidepanel.field-update', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("cYJdB", function(module, exports) {

$parcel$export(module.exports, "applyTemplateMarks", () => $943be4925de62373$export$e7702071f99306f0);
$parcel$export(module.exports, "pageLoad", () => $943be4925de62373$export$791d520f7e8058a5);
$parcel$export(module.exports, "pageLoadWithRateLimit", () => $943be4925de62373$export$5102ef8e92249e0d);
$parcel$export(module.exports, "applyTemplate", () => $943be4925de62373$export$f78a296632f66e69);
$parcel$export(module.exports, "create", () => $943be4925de62373$export$185802fd694ee1f5);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $943be4925de62373$export$e7702071f99306f0 = {
    APPLY_TEMPLATE_POLLING_START_MARK: 'apply_template_polling_start',
    APPLY_TEMPLATE_POLLING_STOP_MARK: 'apply_template_polling_stop'
};
const $943be4925de62373$export$791d520f7e8058a5 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.project', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageLoad
}));
const $943be4925de62373$export$5102ef8e92249e0d = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.project.rate-limit', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageLoad
}));
const $943be4925de62373$export$f78a296632f66e69 = (0, $8XCY1.createMarkedJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.project.apply-template', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'apply_template_polling',
            startMark: $943be4925de62373$export$e7702071f99306f0.APPLY_TEMPLATE_POLLING_START_MARK,
            endMark: $943be4925de62373$export$e7702071f99306f0.APPLY_TEMPLATE_POLLING_STOP_MARK
        }
    ]
}), $943be4925de62373$export$e7702071f99306f0);
const $943be4925de62373$export$185802fd694ee1f5 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.project.create', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("4FxxH", function(module, exports) {

$parcel$export(module.exports, "dialogLoad", () => $c6e3a5461601706c$export$f9bf6b7b75be4461);
$parcel$export(module.exports, "loadStakeholders", () => $c6e3a5461601706c$export$da3bab182f5666a9);
$parcel$export(module.exports, "addStakeholders", () => $c6e3a5461601706c$export$39dc8a3bc2974ed6);
$parcel$export(module.exports, "removeStakeholders", () => $c6e3a5461601706c$export$e7a3e16d74b6c142);
$parcel$export(module.exports, "loadSettings", () => $c6e3a5461601706c$export$54453bb1ffd2fd71);
$parcel$export(module.exports, "updateSettings", () => $c6e3a5461601706c$export$f558026a994b6051);
$parcel$export(module.exports, "loadSiteConfig", () => $c6e3a5461601706c$export$b2e18be8354b8d72);
$parcel$export(module.exports, "loadSitePublicSharingConfig", () => $c6e3a5461601706c$export$85d654471364d5f1);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $c6e3a5461601706c$export$f9bf6b7b75be4461 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.shared.control-dialog-load', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $c6e3a5461601706c$export$da3bab182f5666a9 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.shared.load-stakeholders', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $c6e3a5461601706c$export$39dc8a3bc2974ed6 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.shared.add-stakeholders', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $c6e3a5461601706c$export$e7a3e16d74b6c142 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.shared.remove-stakeholders', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $c6e3a5461601706c$export$54453bb1ffd2fd71 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.shared.load-settings', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $c6e3a5461601706c$export$f558026a994b6051 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.shared.update-settings', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $c6e3a5461601706c$export$b2e18be8354b8d72 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.shared.load-site-config', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $c6e3a5461601706c$export$85d654471364d5f1 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.shared.load-site-public-sharing-config', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("caQ0a", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoad", () => $c8552630708d233d$export$94114666844d5f66);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $c8552630708d233d$export$94114666844d5f66 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.timeline-view', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));

});

parcelRegister("aE5Um", function(module, exports) {

$parcel$export(module.exports, "openDialog", () => $6f224f4fb313fb78$export$45f11db5513b93db);
$parcel$export(module.exports, "loadViewAccess", () => $6f224f4fb313fb78$export$7894161c427d5a42);
$parcel$export(module.exports, "updateViewAccess", () => $6f224f4fb313fb78$export$710acb0a8739a684);
$parcel$export(module.exports, "updatePrincipals", () => $6f224f4fb313fb78$export$a9ab5c1920acd4f5);
$parcel$export(module.exports, "loadCurrentUserViewPermissions", () => $6f224f4fb313fb78$export$b3a1f4fc3f38595c);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $6f224f4fb313fb78$export$45f11db5513b93db = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.view-permissions.open-dialog', {
    type: (0, $2lxLk.ExperienceTypes).Load,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).PageSegmentLoad
}));
const $6f224f4fb313fb78$export$7894161c427d5a42 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.view-permissions.load-view-access', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $6f224f4fb313fb78$export$710acb0a8739a684 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.view-permissions.update-view-access', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $6f224f4fb313fb78$export$a9ab5c1920acd4f5 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.view-permissions.update-principals', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $6f224f4fb313fb78$export$b3a1f4fc3f38595c = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.view-permissions.load-current-user-view-permissions', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("jGUrD", function(module, exports) {

$parcel$export(module.exports, "getView", () => $0bde8ed84e69df14$export$513f42987b822fd7);
$parcel$export(module.exports, "updateView", () => $0bde8ed84e69df14$export$827a6c17a85f6d1a);
$parcel$export(module.exports, "deleteView", () => $0bde8ed84e69df14$export$443d89549b135c95);
$parcel$export(module.exports, "makeGenericIssueFieldUpdate", () => $0bde8ed84e69df14$export$951d66f9bcb4c7fc);
$parcel$export(module.exports, "updateIssueFields", () => $0bde8ed84e69df14$export$fb24ad07bc5a0153);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $0bde8ed84e69df14$export$513f42987b822fd7 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.view.get-view', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $0bde8ed84e69df14$export$827a6c17a85f6d1a = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.view.update-view', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $0bde8ed84e69df14$export$443d89549b135c95 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.view.delete-view', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $0bde8ed84e69df14$export$951d66f9bcb4c7fc = ()=>(0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue-update.field', {
        type: (0, $2lxLk.ExperienceTypes).Experience,
        performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
        timings: [
            {
                key: 'internal_state',
                endMark: 'backend_request_start'
            },
            {
                key: 'backend_request',
                startMark: 'backend_request_start'
            }
        ]
    }));
const $0bde8ed84e69df14$export$fb24ad07bc5a0153 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue-update.fields', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult,
    timings: [
        {
            key: 'internal_state',
            endMark: 'backend_request_start'
        },
        {
            key: 'backend_request',
            startMark: 'backend_request_start'
        }
    ]
}));

});

parcelRegister("kjiOd", function(module, exports) {

$parcel$export(module.exports, "issueConnectionFieldValueUpdate", () => $022e60bffba67a55$export$f339c49235963d2a);
$parcel$export(module.exports, "issueConnectionFieldsValuesUpdateBulk", () => $022e60bffba67a55$export$6fd69dd8cdad62db);
$parcel$export(module.exports, "connectionBetaConfigToggleChange", () => $022e60bffba67a55$export$f6f1d9ce01ba0990);
$parcel$export(module.exports, "connectionBetaConfigLoad", () => $022e60bffba67a55$export$dd51d033a6bac611);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $022e60bffba67a55$export$f339c49235963d2a = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue-update.connection-field', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $022e60bffba67a55$export$6fd69dd8cdad62db = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue-update-bulk.connection-field', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $022e60bffba67a55$export$f6f1d9ce01ba0990 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.connection-beta-config.toggle-change', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $022e60bffba67a55$export$dd51d033a6bac611 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.connection-beta-config.load', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});

parcelRegister("jRmYD", function(module, exports) {

$parcel$export(module.exports, "issueTypesForProjectsLoad", () => $e3c849bf2de5a562$export$b6a12305b3088569);
$parcel$export(module.exports, "issueTypeCreate", () => $e3c849bf2de5a562$export$8eabdcbb38a006a1);
$parcel$export(module.exports, "issueTypeDelete", () => $e3c849bf2de5a562$export$e68e92297750053b);
$parcel$export(module.exports, "issueTypeUpdate", () => $e3c849bf2de5a562$export$539ed317ca253756);
$parcel$export(module.exports, "issueTypePinnedFieldsUpdate", () => $e3c849bf2de5a562$export$82779cf6bc40edd8);

var $2lxLk = parcelRequire("2lxLk");
var $f39LL = parcelRequire("f39LL");

var $8XCY1 = parcelRequire("8XCY1");
const $e3c849bf2de5a562$export$b6a12305b3088569 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue-types.load-all', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $e3c849bf2de5a562$export$8eabdcbb38a006a1 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue-types.create', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $e3c849bf2de5a562$export$e68e92297750053b = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue-types.delete', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $e3c849bf2de5a562$export$539ed317ca253756 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue-types.update', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));
const $e3c849bf2de5a562$export$82779cf6bc40edd8 = (0, $8XCY1.createJpdExperience)(new (0, $f39LL.UFOExperience)('jpd.issue-types.pinned-fields.update', {
    type: (0, $2lxLk.ExperienceTypes).Experience,
    performanceType: (0, $2lxLk.ExperiencePerformanceTypes).InlineResult
}));

});


parcelRegister("e8eEj", function(module, exports) {

$parcel$export(module.exports, "useActiveEntryPointSubject", () => $585ac86971b1700d$export$8332efd58f9ff2b2);
$parcel$export(module.exports, "useActiveEntryPointSubjectActions", () => $585ac86971b1700d$export$1038a97b21d32f52);
$parcel$export(module.exports, "useOpenedOnce", () => $585ac86971b1700d$export$869d2a8dfaa277a0);

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
const $585ac86971b1700d$var$initialState = {
    entryPointReferenceSubject: null,
    openedOnce: false
};
const $585ac86971b1700d$var$actions = {
    setEntryPointReferenceSubject: (entryPointReferenceSubject, openedOnce)=>({ setState: setState, getState: getState })=>{
            if (openedOnce !== undefined) {
                setState({
                    entryPointReferenceSubject: entryPointReferenceSubject,
                    openedOnce: openedOnce
                });
                return;
            }
            setState({
                ...getState(),
                entryPointReferenceSubject: entryPointReferenceSubject
            });
        }
};
const $585ac86971b1700d$var$Store = (0, $GtRbT.createStore)({
    initialState: $585ac86971b1700d$var$initialState,
    actions: $585ac86971b1700d$var$actions,
    name: 'IssueViewJPDIdeasSelectedIdeaStore'
});
const $585ac86971b1700d$export$8332efd58f9ff2b2 = (0, $iJq0l.createHook)($585ac86971b1700d$var$Store, {
    selector: (state)=>state.entryPointReferenceSubject
});
const $585ac86971b1700d$export$1038a97b21d32f52 = (0, $iJq0l.createActionsHook)($585ac86971b1700d$var$Store);
const $585ac86971b1700d$export$869d2a8dfaa277a0 = (0, $iJq0l.createHook)($585ac86971b1700d$var$Store, {
    selector: (state)=>state.openedOnce
});

});

parcelRegister("jycCs", function(module, exports) {

$parcel$export(module.exports, "useIdeaPanelChangeBoarding", () => $368e1fa047585dab$export$f06249435f8d21e7);

var $eJOHy = parcelRequire("eJOHy");

var $a0fwj = parcelRequire("a0fwj");

var $8q7lT = parcelRequire("8q7lT");
const $368e1fa047585dab$var$LOCAL_STORAGE_KEY = 'jpd-viewedIdeaPanelChangeboarding';
const $368e1fa047585dab$export$f06249435f8d21e7 = ()=>{
    const accountId = (0, $8q7lT.useAccountId)();
    const [viewed, setViewed] = (0, $a0fwj.useLocalStorage)($368e1fa047585dab$var$LOCAL_STORAGE_KEY, accountId || 'none', {
        defaultValue: 0
    });
    const handleSetViewed = (0, $eJOHy.useCallback)(()=>{
        setViewed(Date.now());
    }, [
        setViewed
    ]);
    return [
        viewed,
        handleSetViewed
    ];
};

});
parcelRegister("a0fwj", function(module, exports) {

$parcel$export(module.exports, "useLocalStorage", () => $689ce9516e3126f7$export$86e2cef2561044ac);
$parcel$export(module.exports, "useLocalStorageWithExpiry", () => $689ce9516e3126f7$export$9c89ac8256e92fbb);

var $eJOHy = parcelRequire("eJOHy");

var $dnU6V = parcelRequire("dnU6V");
const $689ce9516e3126f7$var$isSetStateFunction = (setStateAction)=>typeof setStateAction === 'function';
const $689ce9516e3126f7$export$86e2cef2561044ac = (namespace, key, options)=>{
    const localStorage = (0, $dnU6V.createLocalStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $eJOHy.useState)(initialValue);
    const setValue = (0, $eJOHy.useCallback)((setStateAction)=>{
        if ($689ce9516e3126f7$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage
    ]);
    return [
        value,
        setValue
    ];
};
const $689ce9516e3126f7$export$9c89ac8256e92fbb = (namespace, key, ttlInMs, options)=>{
    const localStorage = (0, $dnU6V.createLocalExpirableStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $eJOHy.useState)(initialValue);
    const setValue = (0, $eJOHy.useCallback)((setStateAction)=>{
        if ($689ce9516e3126f7$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal, Date.now() + ttlInMs);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction, Date.now() + ttlInMs);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage,
        ttlInMs
    ]);
    return [
        value,
        setValue
    ];
};
const $689ce9516e3126f7$export$436c2fd92113c067 = (namespace, key, options)=>{
    const [state, setState] = $689ce9516e3126f7$export$86e2cef2561044ac(namespace, key, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};
const $689ce9516e3126f7$export$db70e245473ac2a = (namespace, key, ttlInMs, options)=>{
    const [state, setState] = $689ce9516e3126f7$export$9c89ac8256e92fbb(namespace, key, ttlInMs, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};

});


parcelRegister("9FmCE", function(module, exports) {

$parcel$export(module.exports, "useSelectedIdeaKey", () => $1557065c7fa329c9$export$bc4fdd3107ac734d);

var $d60Hm = parcelRequire("d60Hm");
const $1557065c7fa329c9$export$1be222db3ce195b1 = 'onboardingIdeaKey';
const $1557065c7fa329c9$export$bc4fdd3107ac734d = ()=>{
    const params = (0, $d60Hm.getAllUrlParams)();
    return params[$1557065c7fa329c9$export$1be222db3ce195b1];
};

});

parcelRegister("kImJO", function(module, exports) {

$parcel$export(module.exports, "useCrossflowIdeaCardEligible", () => $2804b5fc291cc4be$export$e7231d850b6711d);

var $bmoS1 = parcelRequire("bmoS1");

var $5EgB1 = parcelRequire("5EgB1");

var $dyOHn = parcelRequire("dyOHn");

var $gZTP9 = parcelRequire("gZTP9");

var $lUto7 = parcelRequire("lUto7");

var $bEiQD = parcelRequire("bEiQD");

var $lvKO5 = parcelRequire("lvKO5");
const $2804b5fc291cc4be$var$UNSTARTED_STATUS_CATEGORY_ID = 2;
const $2804b5fc291cc4be$var$EPIC_ISSUE_TYPE_LEVEL = 1;
const $2804b5fc291cc4be$export$e7231d850b6711d = (data)=>{
    const { licensedProducts: licensedProducts } = (0, $lvKO5.useTenantContext)();
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const { isOrgAdmin: isOrgAdmin } = (0, $bEiQD.useIsOrgAdmin)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isEmbedded = (0, $bmoS1.useIsEmbedPageIssueView)();
    const tenantHasActiveJpdLicense = (0, $dyOHn.useSelector)((0, $5EgB1.tenantHasActiveProductDiscoveryLicenseSelector));
    const tenantHasActivatedConfluenceWithin30Days = (0, $dyOHn.useSelector)((0, $5EgB1.hasActivatedConfluenceWithinThirtyDaysSelector));
    const tenantHasConfluence = licensedProducts?.confluence === true;
    if (!data) return false;
    const { issueType: issueType, statusCategoryId: statusCategoryId, canLinkIssues: canLinkIssues } = data;
    const isEpic = issueType.level === $2804b5fc291cc4be$var$EPIC_ISSUE_TYPE_LEVEL;
    const shouldShow = isEpic && Number(statusCategoryId) === $2804b5fc291cc4be$var$UNSTARTED_STATUS_CATEGORY_ID && canLinkIssues && isAdmin && (isOrgAdmin || isSiteAdmin) && !isEmbedded && !tenantHasActiveJpdLicense && !tenantHasActivatedConfluenceWithin30Days && tenantHasConfluence;
    return !!shouldShow;
};

});

parcelRegister("5Pl2q", function(module, exports) {

$parcel$export(module.exports, "ChangeBordingLozenge", () => $be5dfaeb9a040bbc$export$ef4bd866cae9e407);

var $eJOHy = parcelRequire("eJOHy");

var $jdqdp = parcelRequire("jdqdp");

var $lRq8t = parcelRequire("lRq8t");

var $33BlQ = parcelRequire("33BlQ");
const $be5dfaeb9a040bbc$export$ef4bd866cae9e407 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $33BlQ.messages).changeBoardingLozengeLabel));
};

});
parcelRegister("33BlQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6393c44d7f999c7c$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $6393c44d7f999c7c$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    changeBoardingLozengeLabel: {
        "id": "issue-view-jpd-ideas.change-boarding-lozenge.label",
        "defaultMessage": "New"
    }
});

});


parcelRegister("nfbY3", function(module, exports) {

$parcel$export(module.exports, "useAdControlsFunctionality", () => $a9a23055ec36ae27$export$200d7892ced015e6);

var $eJOHy = parcelRequire("eJOHy");

var $FppkK = parcelRequire("FppkK");

var $gYnSx = parcelRequire("gYnSx");

var $1uIew = parcelRequire("1uIew");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $8q7lT = parcelRequire("8q7lT");

var $7DKGa = parcelRequire("7DKGa");
const $a9a23055ec36ae27$var$AD_CONTROLS_FETCH_ERROR = 'adControlsFetchError';
const $a9a23055ec36ae27$export$200d7892ced015e6 = ({ userPropertyCrossflowIdeasCard: crossFlowIdeasCardProperty })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const accountId = (0, $8q7lT.useAccountId)() || '';
    const [isDismissed, setIsDismissed] = (0, $eJOHy.useState)(true);
    const fetchUserProperties = (0, $eJOHy.useCallback)(async ()=>{
        try {
            const res = await (0, $7DKGa.getHasDismissedIdeasCrossflowCard)(accountId, crossFlowIdeasCardProperty);
            setIsDismissed(res);
        } catch (error) {
            setIsDismissed(true);
            let adControlsError;
            if (error instanceof (0, $1uIew.default)) adControlsError = new Error(`Fetch Error, failed to get user property: ${crossFlowIdeasCardProperty}, status code was: ${error.statusCode}`);
            else adControlsError = new Error(`Failed to get user property: ${crossFlowIdeasCardProperty}`, {
                cause: error
            });
            (0, $gYnSx.default)({
                meta: {
                    id: $a9a23055ec36ae27$var$AD_CONTROLS_FETCH_ERROR,
                    packageName: 'issueViewJpdIdeas',
                    teamName: 'galileo'
                },
                error: adControlsError
            });
        }
    }, [
        accountId,
        crossFlowIdeasCardProperty
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (accountId !== '') fetchUserProperties();
    }, [
        accountId,
        fetchUserProperties
    ]);
    const clickedButtonBaseEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const dismiss = (0, $eJOHy.useCallback)(async ()=>{
        setIsDismissed(true);
        (0, $gCeeo.fireUIAnalytics)(clickedButtonBaseEvent, 'notInterested', {
            panelName: 'crossflow-idea-card'
        });
        try {
            (0, $FppkK.setUserProperties)(accountId, crossFlowIdeasCardProperty, 'true');
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: $a9a23055ec36ae27$var$AD_CONTROLS_FETCH_ERROR,
                    packageName: 'issueViewJpdIdeas',
                    teamName: 'galileo'
                },
                error: new Error(`Failed to set user property: ${crossFlowIdeasCardProperty}`, {
                    cause: error
                })
            });
        }
    }, [
        accountId,
        crossFlowIdeasCardProperty,
        clickedButtonBaseEvent
    ]);
    return {
        isDismissed: isDismissed,
        dismiss: dismiss
    };
};

});
parcelRegister("7DKGa", function(module, exports) {

$parcel$export(module.exports, "getHasDismissedIdeasCrossflowCard", () => $5dc4660046b4a4a2$export$6495a88a5dc831ad);

var $1oMOM = parcelRequire("1oMOM");

var $FppkK = parcelRequire("FppkK");

var $1uIew = parcelRequire("1uIew");
const $5dc4660046b4a4a2$export$6495a88a5dc831ad = async (accountId, propertyKey)=>{
    const url = (0, $FppkK.getUserPropertiesUrl)(accountId, propertyKey);
    const response = await fetch(url, (0, $1oMOM.getDefaultOptions)(url));
    if (response.status === 200) {
        const data = await response.json();
        return data.value;
    }
    // 401: If credential is incorrect, the user is not authorised and should not see the banner
    // 403: User doesn't have permission, so they should not see the banner
    if (response.status === 401 || response.status === 403) return true;
    // 404: API deliberately returns 404 if user property is not found, which implies the user has not dismissed the banner
    if (response.status === 404) return false;
    const errorText = await response.text();
    throw new (0, $1uIew.default)(response.status, errorText);
};

});


parcelRegister("eg484", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d81530e4aaa2e45$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $806LH = parcelRequire("806LH");

var $aMdh8 = parcelRequire("aMdh8");

var $8IeH1 = parcelRequire("8IeH1");

var $c5wvT = parcelRequire("c5wvT");
var $bnpBF = parcelRequire("bnpBF");
var $jLzeC = parcelRequire("jLzeC");
var $ckdeJ = parcelRequire("ckdeJ");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");

var $fMthZ = parcelRequire("fMthZ");

var $6S8e9 = parcelRequire("6S8e9");
const $8d81530e4aaa2e45$var$AdControls = ({ onDismissClick: onClickDismiss })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bnpBF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c5wvT.default), {
        itemId: "discover-ideas-issue-view-ad-controls",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                paddingInline: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                testId: "issue-view-jpd-ideas.ui.crossflow-idea-card.ad-controls.menu-button",
                appearance: "subtle",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                    color: "currentColor",
                    label: "more",
                    spacing: "none",
                    LEGACY_size: "small"
                }),
                ref: triggerRef,
                interactionName: "auto-generated.issue-view-jpd-ideas.ui.crossflow-idea-card.ad-controls.button"
            }))
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLzeC.default), {
            ...props,
            testId: "issue-view-jpd-ideas.ui.crossflow-idea-card.ad-controls.discover-ideas-issue-view-ad-controls-dismissal-button",
            flagProps: {
                title: formatMessage((0, $fMthZ.messages).dismissFlagTitle),
                description: formatMessage((0, $fMthZ.messages).dismissFlagDescription)
            },
            onClick: onClickDismiss
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ckdeJ.default), {
            ...props,
            testId: "issue-view-jpd-ideas.ui.crossflow-idea-card.ad-controls.discover-ideas-issue-view-ad-controls-reasons-button",
            itemId: "discover-ideas-issue-view-ad-controls-reasons",
            modalProps: {
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
                    size: "medium"
                }, formatMessage((0, $fMthZ.messages).reasonsModalTitle)),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
                    sourceName: "adControlsReasons",
                    sourceType: (0, $466f60259c330878$export$1171103ea9083ffa)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6S8e9.default), null))
            }
        }))));
};
var $8d81530e4aaa2e45$export$2e2bcd8739ae039 = $8d81530e4aaa2e45$var$AdControls;

});
parcelRegister("fMthZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d4fbfbf4cbeb3d74$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d4fbfbf4cbeb3d74$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    crossflowIdeaSummary: {
        "id": "issue-view-jpd-ideas.crossflow-ideas-summary",
        "defaultMessage": "Supporting idea with customer insights"
    },
    crossflowIdeaTooltip: {
        "id": "issue-view-jpd-ideas.crossflow-ideas-tooltip",
        "defaultMessage": "Create and link an idea to this issue"
    },
    tryLozenge: {
        "id": "issue-view-jpd-ideas.crossflow-ideas-try-lozenge",
        "defaultMessage": "Try"
    },
    privacyPolicy: {
        "id": "issue-view-jpd-ideas.generic-templates.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    dismissFlagTitle: {
        "id": "issue-view-jpd-ideas.dismiss-flag-title",
        "defaultMessage": "Thanks for letting us know"
    },
    dismissFlagDescription: {
        "id": "issue-view-jpd-ideas.dismiss-flag-description",
        "defaultMessage": "You won't be seeing this here anymore"
    },
    closeIdeasTitle: {
        "id": "issue-view-jpd-ideas.close-title",
        "defaultMessage": "Hide section"
    },
    reasonsModalTitle: {
        "id": "issue-view-jpd-ideas.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "issue-view-jpd-ideas.reasons-modal-explanation",
        "defaultMessage": "We think <strong>Jira Product Discovery</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOne: {
        "id": "issue-view-jpd-ideas.reasons-modal-bullet-one",
        "defaultMessage": "the size of your team"
    },
    reasonsModalBulletTwo: {
        "id": "issue-view-jpd-ideas.reasons-modal-bullet-two",
        "defaultMessage": "your existing Atlassian products"
    },
    ideasDismissLabel: {
        "id": "issue-view-jpd-ideas.dismiss-idea-card",
        "defaultMessage": "Dismiss Idea Card"
    }
});

});

parcelRegister("6S8e9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f4c539692c73015$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");


var $fMthZ = parcelRequire("fMthZ");
const $5f4c539692c73015$var$AdControlsReasonsModal = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    (0, $eJOHy.useEffect)(()=>{
        (0, $gCeeo.fireScreenAnalytics)(createAnalyticsEvent({}));
    }, [
        createAnalyticsEvent
    ]);
    const clickedLinkBaseEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link',
        attributes: {
            buttonName: 'adControlsPrivacyPolicy',
            teamName: 'galileo',
            experimentName: 'discover_ideas_in_issue_view'
        }
    });
    const onPrivacyPolicyClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(clickedLinkBaseEvent, 'adControlsPrivacyPolicy');
    }, [
        clickedLinkBaseEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, formatMessage((0, $fMthZ.messages).reasonsModalExplanation, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                as: "strong"
            }, chunks)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $5f4c539692c73015$var$styledBullet
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, formatMessage((0, $fMthZ.messages).reasonsModalBulletOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, formatMessage((0, $fMthZ.messages).reasonsModalBulletTwo)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "link",
        spacing: "none",
        href: (0, $65c042b3fed2d2ff$export$aefe1c8741b24a28),
        target: "_blank",
        onClick: onPrivacyPolicyClick,
        interactionName: "auto-generated.issue-view-jpd-ideas.ui.crossflow-idea-card.ad-controls.button"
    }, formatMessage((0, $fMthZ.messages).privacyPolicy)));
};
var $5f4c539692c73015$export$2e2bcd8739ae039 = $5f4c539692c73015$var$AdControlsReasonsModal;
const $5f4c539692c73015$var$styledBullet = (0, $1DXK0.xcss)({
    marginBottom: 'space.150'
});

});
const $65c042b3fed2d2ff$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';



parcelRegister("3uJXf", function(module, exports) {

$parcel$export(module.exports, "CrossflowIdeaCard", () => $e9aca38ce5c7ad2c$export$d28ee808cdf57a87);

var $eJOHy = parcelRequire("eJOHy");

var $izzcG = parcelRequire("izzcG");

var $6X7AJ = parcelRequire("6X7AJ");
var $dNnxZ = parcelRequire("dNnxZ");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $cfSUy = parcelRequire("cfSUy");

var $jdqdp = parcelRequire("jdqdp");

var $lL4G9 = parcelRequire("lL4G9");
var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $aewX5 = parcelRequire("aewX5");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $lRq8t = parcelRequire("lRq8t");

var $bmoS1 = parcelRequire("bmoS1");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $dUrLZ = parcelRequire("dUrLZ");
var $1Yvty = parcelRequire("1Yvty");

var $fMthZ = parcelRequire("fMthZ");
const $e9aca38ce5c7ad2c$export$d28ee808cdf57a87 = ({ inwardIssueKey: inwardIssueKey, inwardIssueId: inwardIssueId, onDismissAd: onDismissAd })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isFullPageIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const crossFlow = (0, $6X7AJ.useCrossFlow)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $1Yvty.useFireCrossFlowAnalyticsEvents)();
    (0, $eJOHy.useEffect)(()=>{
        fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'card',
            actionSubjectId: 'crossflowIdeaLinkedCard'
        }, {
            recommendedProductIds: [
                (0, $dUrLZ.SURFACE_ANALYTICS_PRODUCT_MAP).products['jira-product-discovery']
            ],
            source: 'jswIssueViewCard'
        });
    }, [
        fireViewedUIEvent
    ]);
    const handleOnClick = (0, $eJOHy.useCallback)(async (e)=>{
        if (crossFlow.isEnabled) {
            (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'card clicked', 'crossflowIdeaLinkedCard', {
                target: isFullPageIssueView ? 'sidebar' : 'newTab',
                inwardIssueKey: inwardIssueKey
            });
            fireInteractedUIEvent({
                action: 'clicked',
                actionSubject: 'card',
                actionSubjectId: 'crossflowIdeaLinkedCard'
            }, {
                recommendedProductIds: [
                    (0, $dUrLZ.SURFACE_ANALYTICS_PRODUCT_MAP).products['jira-product-discovery']
                ],
                targetProductId: (0, $dUrLZ.SURFACE_ANALYTICS_PRODUCT_MAP).products['jira-product-discovery'],
                source: 'jswIssueViewCard'
            });
            // Keep issue view open
            e.preventDefault();
            const extensions = (0, $izzcG.createProvisioningApiExtensions)({
                actions: {
                    primary: {
                        behaviour: (0, $izzcG.Behaviours).LAND,
                        prompt: (0, $izzcG.Prompts).RETURN_TO_PRODUCT,
                        options: {
                            targetTab: (0, $izzcG.TargetTabs).NEW,
                            urlParams: {
                                SELECTED_ISSUE_PARAM: inwardIssueKey
                            }
                        }
                    }
                },
                jobName: 'jira-jpd-issueview-link',
                jobParams: {
                    inwardIssueKey: inwardIssueKey,
                    inwardIssueId: inwardIssueId
                }
            });
            await crossFlow.apiV1.open({
                journey: (0, $6X7AJ.Journeys).GET_STARTED,
                sourceComponent: 'crossflowIdeaLinkedCard',
                sourceContext: 'crossflowIdeaLinkedCard',
                targetProduct: (0, $dNnxZ.Targets).JIRA_PRODUCT_DISCOVERY,
                extensions: extensions,
                v1: true
            });
        }
    }, [
        crossFlow,
        createAnalyticsEvent,
        fireInteractedUIEvent,
        isFullPageIssueView,
        inwardIssueKey,
        inwardIssueId
    ]);
    const handleDismissClick = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        onDismissAd();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        href: `/browse/${inwardIssueKey}`,
        onClick: handleOnClick,
        xcss: (0, $6XJko.isVisualRefreshEnabled)() ? $e9aca38ce5c7ad2c$var$ideaCardStyles : $e9aca38ce5c7ad2c$var$ideaCardStylesOld,
        testId: "issue-view-jpd-ideas.ui.crossflow-idea-card.crossflow-linked-idea-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aewX5.default), {
        templateColumns: "20px 1fr",
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $fMthZ.messages).crossflowIdeaTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cfSUy))), {
        testId: "issue-view-jpd-ideas.ui.crossflow-idea-card.crossflow-linked-idea-card-icon",
        color: "var(--ds-text-accent-orange, #A54800)",
        label: formatMessage((0, $fMthZ.messages).tryLozenge)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        maxLines: 1
    }, formatMessage((0, $fMthZ.messages).crossflowIdeaSummary)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $e9aca38ce5c7ad2c$var$lozengeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $fMthZ.messages).tryLozenge))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $fMthZ.messages).closeIdeasTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))),
        label: formatMessage((0, $fMthZ.messages).ideasDismissLabel),
        appearance: "subtle",
        onClick: handleDismissClick,
        testId: "issue-view-jpd-ideas.ui.crossflow-idea-card.issue-view-jpd-ideas-dismiss-idea-card"
    })));
};
const $e9aca38ce5c7ad2c$var$ideaCardStyles = (0, $1DXK0.xcss)({
    textDecoration: 'none',
    background: 'none',
    cursor: 'pointer',
    border: 'solid',
    borderColor: 'color.border',
    borderWidth: '0px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderRightWidth: '1px',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    display: 'flex',
    alignItems: 'center',
    height: '40px',
    justifyContent: 'space-between',
    transition: '0.3s',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':first-of-type': {
        borderTopWidth: '1px',
        borderTopLeftRadius: 'border.radius',
        borderTopRightRadius: 'border.radius'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderBottomWidth: '1px',
        borderBottomLeftRadius: 'border.radius',
        borderBottomRightRadius: 'border.radius'
    }
});
const $e9aca38ce5c7ad2c$var$ideaCardStylesOld = (0, $1DXK0.xcss)({
    borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`,
    display: 'flex',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    height: '40px',
    alignItems: 'center',
    transition: '0.3s',
    cursor: 'pointer',
    color: 'color.text',
    textDecoration: 'none',
    justifyContent: 'space-between',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':last-child': {
        border: 'none'
    }
});
const $e9aca38ce5c7ad2c$var$lozengeStyles = (0, $1DXK0.xcss)({
    marginLeft: 'space.100'
});

});

parcelRegister("5XbzI", function(module, exports) {

$parcel$export(module.exports, "IdeaCard", () => $2cf7c635fdf39c1d$export$defacd58a1b26c47);

var $eJOHy = parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $aewX5 = parcelRequire("aewX5");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $ciFJV = parcelRequire("ciFJV");

var $bbdV2 = parcelRequire("bbdV2");

var $bmoS1 = parcelRequire("bmoS1");

var $ifYrA = parcelRequire("ifYrA");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kEUB1 = parcelRequire("kEUB1");

var $6XJko = parcelRequire("6XJko");

var $gslMM = parcelRequire("gslMM");

var $e8eEj = parcelRequire("e8eEj");

var $jycCs = parcelRequire("jycCs");

var $3tENT = parcelRequire("3tENT");
const $2cf7c635fdf39c1d$export$defacd58a1b26c47 = ({ summary: summary, issueKey: issueKey, issueId: issueId, issueTypeIconUrl: issueTypeIconUrl, issueTypeName: issueTypeName, issueLinkId: issueLinkId, isUrlSelected: isUrlSelected, onUnlinkModalConfirmed: onUnlinkModalConfirmed })=>{
    const [_, setViewedChangeBoarding] = (0, $jycCs.useIdeaPanelChangeBoarding)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isFullPageIssueView = (0, $bmoS1.useIsFullPageIssueView)();
    const cloudId = (0, $kEUB1.useCloudId)();
    const [isHovered, hoverProps] = (0, $gslMM.useHoverState)();
    const { setEntryPointReferenceSubject: setEntryPointReferenceSubject } = (0, $e8eEj.useActiveEntryPointSubjectActions)();
    const [openedOnce] = (0, $e8eEj.useOpenedOnce)();
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            issueKey: issueKey,
            cloudId: cloudId
        }), [
        cloudId,
        issueKey
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $bbdV2.useEntryPoint)((0, $ifYrA.IdeaViewBentoSidebarEntryPoint), entryPointParams);
    const triggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(entryPointActions);
    const handleOnClick = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        if (isFullPageIssueView) {
            setEntryPointReferenceSubject(entryPointReferenceSubject);
            setViewedChangeBoarding();
        } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(`/browse/${issueKey}`, '_blank');
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({}), 'card clicked', 'ideaLinkedCard', {
            target: isFullPageIssueView ? 'sidebar' : 'newTab',
            clickedIssueId: issueId
        });
    }, [
        issueKey,
        createAnalyticsEvent,
        isFullPageIssueView,
        issueId,
        setEntryPointReferenceSubject,
        entryPointReferenceSubject,
        setViewedChangeBoarding
    ]);
    /* will not cause endless loop because of the `isUrlSelected` and `openedOnce` dependency */ // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        if (isUrlSelected && !openedOnce) {
            entryPointActions.load();
            setEntryPointReferenceSubject(entryPointReferenceSubject);
        }
    }, [
        entryPointActions,
        entryPointReferenceSubject,
        isUrlSelected,
        openedOnce,
        setEntryPointReferenceSubject,
        createAnalyticsEvent
    ]);
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "issue-view-jpd-ideas.ui.idea-card.idea-card",
        ref: triggerRef,
        onClick: handleOnClick,
        xcss: (0, $6XJko.isVisualRefreshEnabled)() ? $2cf7c635fdf39c1d$var$ideaCardStyles : $2cf7c635fdf39c1d$var$ideaCardStylesOld,
        onMouseOver: hoverProps.onMouseOver,
        onFocus: hoverProps.onFocus,
        onMouseOut: hoverProps.onMouseOut,
        onBlur: hoverProps.onBlur
    }, isUrlSelected && !openedOnce && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "ideaViewBentoSidebarWithOnboardingIdeaKey",
        sourceType: (0, $466f60259c330878$export$9d2de6eebf7462b5),
        attributes: {
            issueKey: issueKey,
            issueId: issueId,
            issueLinkId: issueLinkId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aewX5.default), {
        templateColumns: issueTypeIconUrl ? '20px 1fr' : '1fr',
        gap: "space.100"
    }, issueTypeIconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: issueTypeName || null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        appearance: "square",
        src: issueTypeIconUrl,
        size: "xsmall",
        borderColor: "transparent"
    }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        maxLines: 1
    }, summary)), issueLinkId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3tENT.IdeaUnlinkCrossButton), {
        issueKey: issueKey,
        issueLinkId: issueLinkId,
        isParentHovered: isHovered,
        onUnlinkModalConfirmed: onUnlinkModalConfirmed
    })));
};
const $2cf7c635fdf39c1d$var$ideaCardStyles = (0, $1DXK0.xcss)({
    textDecoration: 'none',
    background: 'none',
    cursor: 'pointer',
    border: 'solid',
    borderColor: 'color.border',
    borderWidth: '0px',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderRightWidth: '1px',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    display: 'flex',
    alignItems: 'center',
    height: '40px',
    justifyContent: 'space-between',
    transition: '0.3s',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':first-of-type': {
        borderTopWidth: '1px',
        borderTopLeftRadius: 'border.radius',
        borderTopRightRadius: 'border.radius'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        borderBottomWidth: '1px',
        borderBottomLeftRadius: 'border.radius',
        borderBottomRightRadius: 'border.radius'
    }
});
const $2cf7c635fdf39c1d$var$ideaCardStylesOld = (0, $1DXK0.xcss)({
    borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`,
    display: 'flex',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    height: '40px',
    alignItems: 'center',
    transition: '0.3s',
    cursor: 'pointer',
    color: 'color.text',
    textDecoration: 'none',
    justifyContent: 'space-between',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        color: 'color.text'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':last-child': {
        border: 'none'
    }
});

});
parcelRegister("ifYrA", function(module, exports) {

$parcel$export(module.exports, "IdeaViewBentoSidebarEntryPoint", () => $3646b4c555b2b37c$export$8c0cc591c2ad86ce);

var $9R0Oz = parcelRequire("9R0Oz");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $3646b4c555b2b37c$export$8c0cc591c2ad86ce = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("3wLoJ")), {
        moduleId: "96c40e89",
        priority: "interaction"
    }),
    getPreloadProps: ({ issueKey: issueKey, cloudId: cloudId })=>({
            queries: {
                issueData: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $9R0Oz.default,
                    variables: {
                        issueKey: issueKey,
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("9R0Oz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5780b0adf57e0210$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d9a4f40b8cf9ddde23c9f4b9cef23159>>
 * @relayHash 0f3fdcb25dffe19635701945cd438883
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b4ff6a9e3f370e691d8f2d6798098bfa3f2cd9a93e2bceff5e7c72b0bf0f91f3
const $5780b0adf57e0210$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v7 = {
        "kind": "ScalarField",
        "name": "text"
    }, v8 = {
        "concreteType": "JiraRichText",
        "kind": "LinkedField",
        "name": "richText",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraADF",
                "kind": "LinkedField",
                "name": "adfValue",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "json"
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v11 = [
        {
            "kind": "Literal",
            "name": "ids",
            "value": [
                "project"
            ]
        }
    ], v12 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_JPDIdeaViewBentoSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleLineTextField",
                                    "kind": "LinkedField",
                                    "name": "summaryField",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraRichTextField",
                                    "kind": "LinkedField",
                                    "name": "descriptionField",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldsById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v10 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraProjectField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "fieldsById(ids:[\"project\"])"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ui_JPDIdeaViewBentoSidebarQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleLineTextField",
                                    "kind": "LinkedField",
                                    "name": "summaryField",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraRichTextField",
                                    "kind": "LinkedField",
                                    "name": "descriptionField",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        v14 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v11 /*: any*/ ,
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldsById",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraProject",
                                                                    "kind": "LinkedField",
                                                                    "name": "project",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v13 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v4 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraProjectField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "fieldsById(ids:[\"project\"])"
                                },
                                v14 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b4ff6a9e3f370e691d8f2d6798098bfa3f2cd9a93e2bceff5e7c72b0bf0f91f3",
            "metadata": {},
            "name": "ui_JPDIdeaViewBentoSidebarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$5780b0adf57e0210$var$node.hash = "356c28d00e08cb22177ffdeb850e6f52";
var $5780b0adf57e0210$export$2e2bcd8739ae039 = $5780b0adf57e0210$var$node;

});

parcelRegister("3wLoJ", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
        return Promise.all([
            $ewTvA("8cTbf")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("aWLqK")
        ]);
    }),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("hwqiT")
]).then(()=>parcelRequire('kIBLO'));

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            console.error('Conditional dependency was not registered when executing. Falling back to synchronous bundle loading.');
            for (const url of fallback.urls)fallback.loader(url);
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});



parcelRegister("gslMM", function(module, exports) {

$parcel$export(module.exports, "useHoverState", () => $3456ba63d5cd851f$export$66bed54b0a694e74);

var $eJOHy = parcelRequire("eJOHy");
const $3456ba63d5cd851f$export$66bed54b0a694e74 = ()=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const onMouseOver = ()=>{
        setIsHovered(true);
    };
    const onMouseOut = ()=>{
        setIsHovered(false);
    };
    const onFocus = ()=>{
        setIsHovered(true);
    };
    const onBlur = ()=>{
        setIsHovered(false);
    };
    return [
        isHovered,
        {
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            onFocus: onFocus,
            onBlur: onBlur
        }
    ];
};

});

parcelRegister("3tENT", function(module, exports) {

$parcel$export(module.exports, "IdeaUnlinkCrossButton", () => $5316a991f45c7d51$export$8004561cccbfec39);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");
var $Ay1uj = parcelRequire("Ay1uj");

var $5wxTT = parcelRequire("5wxTT");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");
var $956it = parcelRequire("956it");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $aC4Bh = parcelRequire("aC4Bh");

var $lRq8t = parcelRequire("lRq8t");

var $kGu4J = parcelRequire("kGu4J");
const $5316a991f45c7d51$export$8004561cccbfec39 = ({ issueKey: issueKey, issueLinkId: issueLinkId, isParentHovered: isParentHovered, onUnlinkModalConfirmed: onUnlinkModalConfirmed })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const openModal = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(true);
    }, []);
    const closeModal = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(false);
    }, []);
    const confirmUnlink = (0, $eJOHy.useCallback)((e)=>{
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(false);
        onUnlinkModalConfirmed(issueLinkId);
    }, [
        issueLinkId,
        onUnlinkModalConfirmed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: isParentHovered ? undefined : $5316a991f45c7d51$var$invisibleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5wxTT))),
        label: formatMessage((0, $kGu4J.messages).unlinkButtonTooltip),
        spacing: "compact",
        appearance: "subtle",
        onClick: openModal,
        testId: "issue-view-jpd-ideas.ui.idea-card.idea-unlink-cross-button.icon-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5316a991f45c7d51$export$1f33f980da756c46, {
        issueKey: issueKey,
        onClose: closeModal,
        onConfirm: confirmUnlink
    })));
};
const $5316a991f45c7d51$export$1f33f980da756c46 = ({ onClose: onClose, onConfirm: onConfirm, issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        messageId: "issue-view-jpd-ideas.ui.idea-card.idea-unlink-cross-button.modal",
        messageType: "transactional",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "warning"
    }, formatMessage((0, $kGu4J.messages).unlinkModalTitle, {
        issueKey: issueKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, formatMessage((0, $kGu4J.messages).unlinkModalBody)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $kGu4J.messages).unlinkModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "warning",
        onClick: onConfirm
    }, formatMessage((0, $kGu4J.messages).unlinkModalConfirmButton))));
};
const $5316a991f45c7d51$var$invisibleStyles = (0, $1DXK0.xcss)({
    visibility: 'hidden'
});

});
parcelRegister("kGu4J", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d354c59bcbeffcab$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $d354c59bcbeffcab$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    unlinkButtonTooltip: {
        "id": "issue-view-jpd-ideas.idea-card.idea-unlink-cross-button.unlink-button-tooltip",
        "defaultMessage": "Unlink idea"
    },
    unlinkModalTitle: {
        "id": "issue-view-jpd-ideas.idea-card.idea-unlink-cross-button.unlink-modal-title",
        "defaultMessage": "Remove the link to {issueKey}"
    },
    unlinkModalBody: {
        "id": "issue-view-jpd-ideas.idea-card.idea-unlink-cross-button.unlink-modal-body",
        "defaultMessage": "You can add it again later if you need to."
    },
    unlinkModalConfirmButton: {
        "id": "issue-view-jpd-ideas.idea-card.idea-unlink-cross-button.unlink-modal-confirm-button",
        "defaultMessage": "Remove"
    },
    unlinkModalCancelButton: {
        "id": "issue-view-jpd-ideas.idea-card.idea-unlink-cross-button.unlink-modal-cancel-button",
        "defaultMessage": "Cancel"
    }
});

});



parcelRegister("kWDaK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $89851e6fa1bb34b2$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $89851e6fa1bb34b2$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    ideasTitle: {
        "id": "issue-view-jpd-ideas.ideas-title",
        "defaultMessage": "Ideas"
    },
    ideasPickerPlaceholder: {
        "id": "issue-view-jpd-ideas.ideas-picker-placeholder",
        "defaultMessage": "Search for ideas"
    },
    plusButtonLabel: {
        "id": "issue-view-jpd-ideas.plus-button-label",
        "defaultMessage": "Add"
    },
    linkButton: {
        "id": "issue-view-jpd-ideas.link-button",
        "defaultMessage": "Link"
    },
    cancelButton: {
        "id": "issue-view-jpd-ideas.cancel-button",
        "defaultMessage": "Cancel"
    },
    linkIdeaErrorFlagTitle: {
        "id": "issue-view-jpd-ideas.link-idea-error-flag-title",
        "defaultMessage": "We couldn't link your ideas"
    },
    linkIdeaErrorFlagDescription: {
        "id": "issue-view-jpd-ideas.link-idea-error-flag-description",
        "defaultMessage": "We couldn't link your ideas. Refresh and try again."
    },
    unlinkIdeaErrorFlagTitle: {
        "id": "issue-view-jpd-ideas.unlink-idea-error-flag-title",
        "defaultMessage": "We couldn't unlink your idea"
    },
    unlinkIdeaErrorFlagDescription: {
        "id": "issue-view-jpd-ideas.unlink-idea-error-flag-description",
        "defaultMessage": "We couldn't unlink your idea. Refresh and try again."
    },
    fallbackIdeaName: {
        "id": "issue-view-jpd-ideas.crossflow-ideas-fallback-idea-name",
        "defaultMessage": "My supporting idea"
    }
});

});

parcelRegister("aVRzo", function(module, exports) {

$parcel$export(module.exports, "createAddJPDLinkEntrypoint", () => $36d0833dca770a03$export$cea54be96af46d8e);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $36d0833dca770a03$export$cea54be96af46d8e = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("1CNn9")), {
        moduleId: "0aadef03",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1CNn9", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");

module.exports = Promise.all([
    (parcelRequire("g81qY"))('fy26_nike_box_bundle_decrease_project', function() {
        return Promise.all([
            $ewTvA("lpg1K")
        ]);
    }, function() {
        return Promise.all([
            $ewTvA("8D3kc"),
            $ewTvA("kVX56")
        ]);
    }),
    $ewTvA("geoiO")
]).then(()=>parcelRequire('kXSot'));

});




$parcel$global.rlb("8LUjY")
//# sourceMappingURL=ui.6af88e55.js.map
